export default class PairHistory {
  public device: string;
  public epochFriendly: string;
  public action: string;
  epoch: number;

  constructor(data: any) {
    this.device = data["Device"];
    this.epochFriendly = data["EPOCH:friendly"];
    this.action = data["Action"];
    this.epoch = data["Epoch"];
  }
}

